class BlogSearch extends HTMLElement {
  constructor() {
      super();
      let input = document.querySelector('#blog-search-input');
      let submit = document.querySelector('#blog-search-go');
      let reset = document.querySelector('#blog-search-reset');
      input.addEventListener('input', this.getTerms.bind(this));
      submit.addEventListener('click', this.getSearch.bind(this));
      reset.addEventListener('click', this.resetAll.bind(this));
  }

  getTerms(e) {
      this.setAttribute("data-query", e.currentTarget.value);
  }

  getSearch(e) {
      e.preventDefault();

      // document.addEventListener("keydown", (e) => {
      //   if(e.keyCode == 13) {
      //     return false;
      //   }
      // });

      let query = this.getAttribute("data-query");

      fetch(window.Shopify.routes.root + `search/suggest.json?q=${query}&resources[type]=article`)
          .then((response) => response.json())
          .then((suggestions) => {
              // console.log(suggestions.resources.results.articles);
              let data = suggestions?.resources?.results?.articles
              this.setAttribute('data-done', true);
              document.querySelector('#results').classList.add('active');

              if(data.length == 0){
                this.renderNoResults();
              } else {
                this.renderResults(data);
              }
          });
  }


  renderResults(data) {
    
      document.querySelector('#results').setAttribute('data-count', data.length);
      document.querySelector('#blog-search-reset').classList.remove('visually-hidden');

      let title = `<h3>Results for "${this.getAttribute("data-query")}"</h3>`;
      let template = data.map((d, i) => {
          return (
              `<div class="blog-articles__article article" id="${d.id}">
      <div class="card article-card">
        <div class="article-card__inner">
          <div class="article-card__image-wrapper">
            <a href="${d.url}" class="article-card__image">
              <img src="${d.featured_image.url}" />
            </a>
          </div>
          <div class="article-card__content">
            <div class="article-card__info">
              <span>${d.tags}</span>
              <span></span>
            </div>
            <a href="${d.url}">
              <h3 class="article-card__heading">${d.title}</h3>
            </a>
            <p class="article-card__excerpt">${d.summary_html}</p>
          </div>
        </div>
      </div>
    </div>`
          )
      }).join('');

      this.hydrateResults(template, title);
  }

  renderNoResults(){
    document.querySelector('#results').setAttribute('data-count', 0);
    let title= "<h3>No results found...</h3>"
    let template = ``;
    this.hydrateResults(template, title);
  }


  hydrateResults(t,s) {
      document.querySelector('#results .title').innerHTML = s;
      document.querySelector('#results .inner').innerHTML = t;
  }

  resetAll(){
    document.querySelector('#results .title').innerHTML = "";
    document.querySelector('#results .inner').innerHTML = "";
    document.querySelector('#results').classList.remove('active');
    document.querySelector('#blog-search-reset').classList.add('visually-hidden');
    document.querySelector('#blog-search-input').value = "";
  }

}

customElements.define("blog-search", BlogSearch);